var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "person-info" }, [
    _c(
      "section",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading"
          }
        ]
      },
      [
        _c("div", { staticClass: "template-title" }, [_vm._v("参赛人员信息")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "header-info" },
          [
            _c("player-info", { staticClass: "player-wrapper" }),
            _vm._v(" "),
            _vm.auditTitle.show
              ? _c("p", { style: { color: _vm.auditTitle.color } }, [
                  _vm._v(_vm._s(_vm.auditTitle.text))
                ])
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "template-title" }, [
          _vm._v("竞赛材料提交要求")
        ]),
        _vm._v(" "),
        _c("div", {
          staticClass: "template-description",
          domProps: { innerHTML: _vm._s(_vm.activityDesc) }
        }),
        _vm._v(" "),
        _vm._l(_vm.sections, function(template, index) {
          return _c("div", { key: index, staticClass: "template-wrapper" }, [
            _c("div", { staticClass: "title-wrapper" }, [
              _c("p", { staticClass: "template-title" }, [
                _vm._v(_vm._s(template ? template.title : ""))
              ])
            ]),
            _vm._v(" "),
            _c("p", {
              staticClass: "description",
              class: {
                "template-description":
                  template && template.type !== "description",
                "template-title": template && template.type === "description"
              },
              domProps: {
                innerHTML: _vm._s(
                  _vm.filterDescMark(template ? template.desc : "")
                )
              }
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "template-file-list" },
              [
                _c("file-uploader", {
                  attrs: {
                    canDownload: _vm.download,
                    fileDesc: template ? template.desc : "",
                    rejectFileIdList: _vm.rejectFileIdList,
                    type: template ? template.type : "",
                    status: _vm.status,
                    activityId: _vm.activity_id,
                    playerId: _vm.player_id,
                    typesItemIndex: index,
                    attachmentId: template.attachmentId,
                    isUploadingMode: true
                  },
                  on: {
                    downloadAttachment: _vm.downloadAttachment,
                    itemUploadSuccess: _vm.itemUploadSuccess,
                    deleteItem: _vm.deleteItem
                  },
                  model: {
                    value: template.materials,
                    callback: function($$v) {
                      _vm.$set(template, "materials", $$v)
                    },
                    expression: "template.materials"
                  }
                })
              ],
              1
            )
          ])
        })
      ],
      2
    ),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c(
      "footer",
      [
        _vm.status === "refuse"
          ? _c(
              "el-button",
              {
                staticClass: "btn-confirm",
                attrs: { type: "primary", disabled: _vm.btnActive },
                on: { click: _vm.submit }
              },
              [_vm._v("提交修改\n    ")]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.status === "uncommitted"
          ? _c(
              "el-button",
              {
                staticClass: "btn-confirm",
                attrs: { type: "primary", disabled: _vm.btnActive },
                on: { click: _vm.submit }
              },
              [_vm._v("\n      提交\n    ")]
            )
          : _vm._e()
      ],
      1
    ),
    _vm._v(" "),
    _vm.shouldShowAudit
      ? _c(
          "div",
          { staticClass: "audit-record" },
          [
            _c("p", { staticClass: "audit-record-title" }, [
              _vm._v("审核记录")
            ]),
            _vm._v(" "),
            _vm._l(_vm.audit_record, function(record, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "audit-wrapper",
                  class: { "audit-wrapper--first-child": index === 0 }
                },
                [
                  _c("div", {
                    staticClass: "icon-warpper",
                    class: _vm.shouldShowIconWidth(record.status)
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "content" }, [
                    _c("div", { staticStyle: { display: "flex" } }, [
                      _c(
                        "p",
                        {
                          staticClass: "audit-time",
                          staticStyle: { "margin-right": "5px" }
                        },
                        [_vm._v("审核时间:")]
                      ),
                      _vm._v(" "),
                      _c("p", { staticClass: "audit-time" }, [
                        _vm._v(_vm._s(record.time))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticStyle: { display: "flex" } }, [
                      _c("p", { staticStyle: { "margin-right": "5px" } }, [
                        _vm._v("审核结果：")
                      ]),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "audit-result",
                          class: { reject: record.status === "rejected" }
                        },
                        [_vm._v(_vm._s(record.statusTxt))]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticStyle: { display: "flex" } }, [
                      _c("p", { staticClass: "audit-recommend" }, [
                        _vm._v("审核意见：")
                      ]),
                      _vm._v(" "),
                      _c("p", {
                        staticClass: "audit-recommend",
                        staticStyle: { flex: "1" },
                        domProps: {
                          innerHTML: _vm._s(
                            record.opinion
                              ? record.opinion
                                  .replace(/\r\n/g, "<br>")
                                  .replace(/\n/g, "<br>")
                                  .replace(/\s/g, "&nbsp;")
                              : ""
                          )
                        }
                      })
                    ])
                  ])
                ]
              )
            })
          ],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "info-warpper" }, [
      _c("p", [_vm._v("注意事项：")]),
      _vm._v(" "),
      _c("p", [_vm._v("1.标题与附件为必填项；")]),
      _vm._v(" "),
      _c("p", [
        _vm._v("2.根据格式不同需上传相应格式的附件，若格式错误将无法成功上传；")
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("3.竞赛材料一经提交，将进入材料审核流程，期间文件不可更改。")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2cc069dd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2cc069dd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/PersonInfo.vue
// module id = null
// module chunks = 